import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-131">
      <div className="max-w-xl mx-auto" data-id="element-132">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-133">
          Garanzia totale
        </p>
        <h2 className="text-2xl sm:text-3xl font-black text-center text-brand-cream mb-6" data-id="element-134">
          Rischio zero, 14 giorni di prova
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-135">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-136" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-137" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-3 relative z-10" data-id="element-138" />

          <div className="relative z-10 mb-4" data-id="element-139">
            <div className="text-4xl font-black text-brand-gold" data-id="element-140">14 Giorni</div>
          </div>

          <h3 className="text-xl sm:text-2xl font-black text-brand-cream uppercase mb-3 relative z-10" data-id="element-141">
            Recupera il tuo tempo, o ti rimborsiamo.
          </h3>

          <p className="text-gray-300 text-sm sm:text-base font-medium leading-relaxed relative z-10 mb-5" data-id="element-142">
            Siamo così sicuri di Lettere Pronte che ti diamo 14 giorni interi
            per metterlo alla prova. Se non senti che il tuo lavoro è diventato
            più veloce, facile e organizzato, ti restituiamo ogni centesimo.
          </p>

          <div className="grid grid-cols-1 gap-3 text-left relative z-10 mb-5" data-id="element-143">
            {[{
            t: 'Rimborso integrale',
            d: 'Ti restituiamo ogni centesimo, senza trattenute.'
          }, {
            t: 'Senza domande',
            d: "Nessuna giustificazione richiesta. Basta un'email."
          }, {
            t: 'Procedura semplice',
            d: 'Una sola mail e in 24h ricevi conferma del rimborso.'
          }].map((row, i) => <div key={i} className="bg-brand-dark/60 border border-white/5 rounded-xl p-3" data-id="element-144">
                <div className="font-bold text-brand-gold text-sm" data-id="element-145">{row.t}</div>
                <div className="text-gray-400 text-xs sm:text-sm" data-id="element-146">{row.d}</div>
              </div>)}
          </div>

          <p className="text-brand-cream font-bold text-sm sm:text-base relative z-10" data-id="element-147">
            Tu provi, noi ci assumiamo il rischio.
          </p>
        </motion.div>
      </div>
    </section>;
}